/* Grihvas product page v4: MRP price block, bulk tiers, animated quantity.
   Loaded before grihvas.js so this gv-product definition wins. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.23,1,.32,1)';
  function fmt(c) { var v = Math.round(c) / 100; return '₹' + v.toLocaleString('en-IN', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }); }
  function tick(el, dir) {
    if (reduce || !el || !el.animate || !dir) return;
    el.animate([{ transform: 'translateY(' + (dir > 0 ? '45%' : '-45%') + ')', opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }], { duration: 200, easing: EASE });
  }
  window.gvTick = tick;
  window.gvFmt = fmt;

  class GvProduct extends HTMLElement {
    connectedCallback() {
      var $ = (s) => this.querySelector(s);
      this.$ = $;
      this.btn = $('[data-gv-add]');
      this.face = this.btn ? this.btn.querySelector('[data-gv-face]') : null;
      this.q = $('[data-gv-qty]');
      this.tiers = Array.from(this.querySelectorAll('[data-gv-tier]'));
      var checked = this.querySelector('input[name="id"]:checked') || this.querySelector('input[name="id"]');
      this.cents = parseInt((checked && checked.dataset.cents) || this.dataset.cents || '0', 10);
      this.avail = this.btn ? !this.btn.disabled : true;
      this.querySelectorAll('input[name="id"][type="radio"]').forEach((r) => r.addEventListener('change', () => this.update(r)));
      if (this.q) {
        this.querySelectorAll('[data-gv-step]').forEach((b) => b.addEventListener('click', () => {
          var d = parseInt(b.dataset.gvStep, 10);
          this.setQty((parseInt(this.q.value, 10) || 1) + d, d);
        }));
        this.q.addEventListener('input', () => this.refresh());
        this.q.addEventListener('change', () => this.setQty(this.q.value, 0));
      }
      this.tiers.forEach((t) => t.addEventListener('change', () => {
        var n = parseInt(t.value, 10), cur = this.q ? parseInt(this.q.value, 10) || 1 : 1;
        this.setQty(n, n > cur ? 1 : -1);
      }));
      var pinBtn = $('[data-gv-pin-btn]'), pin = $('[data-gv-pin]'), msg = $('[data-gv-pin-msg]');
      if (pinBtn && pin && msg) {
        pinBtn.addEventListener('click', () => {
          var ok = /^[1-9][0-9]{5}$/.test(pin.value.trim());
          msg.textContent = ok ? msg.dataset.ok : msg.dataset.bad;
          msg.style.color = ok ? 'var(--gv-green)' : 'var(--gv-red)';
        });
      }
      this.refresh();
    }
    setQty(v, dir) {
      var n = Math.max(1, Math.min(999, parseInt(v, 10) || 1));
      if (this.q) {
        var changed = String(n) !== this.q.value;
        this.q.value = n;
        if (changed) tick(this.q, dir);
      }
      this.refresh();
    }
    tierFor(n) {
      var res = { pct: 0, el: null };
      this.tiers.forEach((t) => { if (n >= parseInt(t.value, 10)) { res.pct = parseInt(t.dataset.pct || '0', 10); res.el = t; } });
      return res;
    }
    refresh() {
      var n = this.q ? Math.max(1, parseInt(this.q.value, 10) || 1) : 1;
      var t = this.tierFor(n);
      if (t.el && !t.el.checked) t.el.checked = true;
      this.tiers.forEach((tr) => {
        var each = tr.closest('.gv-tier') && tr.closest('.gv-tier').querySelector('[data-gv-each]');
        if (each) each.textContent = fmt(Math.round(this.cents * (1 - parseInt(tr.dataset.pct || '0', 10) / 100) / 100) * 100) + ' each';
      });
      var total = this.cents * n, disc = Math.round(total * t.pct / 100);
      var note = this.$('[data-gv-tier-note]');
      if (note) note.innerHTML = t.pct ? 'You save <b>' + fmt(disc) + '</b> on ' + n + ' pcs. Applied automatically in your bag.' : note.dataset.idle;
      if (this.face) this.face.textContent = this.avail ? ((n > 1 ? 'Add ' + n + ' to bag' : 'Add to bag') + ' · ' + fmt(total - disc)) : (this.btn.dataset.soldout || 'Sold out');
      document.dispatchEvent(new CustomEvent('gv:product-change'));
    }
    update(r) {
      var d = r.dataset, $ = this.$;
      this.cents = parseInt(d.cents || '0', 10);
      this.avail = d.available === 'true';
      var now = $('[data-gv-now]'); if (now) now.textContent = d.price;
      var mrp = $('[data-gv-mrp]'), was = $('[data-gv-was]'), off = $('[data-gv-offpct]');
      if (was) was.textContent = d.compare || '';
      if (mrp) mrp.hidden = !d.compare;
      if (off) { off.textContent = d.off ? '-' + d.off + '%' : ''; off.hidden = !d.off; }
      if (this.btn) this.btn.disabled = !this.avail;
      var st = $('[data-gv-stock]'); if (st) st.hidden = !this.avail;
      var so = $('[data-gv-stock-out]'); if (so) so.hidden = this.avail;
      if (d.media) { var g = document.querySelector('gv-gallery'); if (g && g.show) g.show(d.media); }
      try { var u = new URL(window.location.href); u.searchParams.set('variant', r.value); history.replaceState(null, '', u.toString()); } catch (e) {}
      this.refresh();
    }
  }
  if (!customElements.get('gv-product')) customElements.define('gv-product', GvProduct);
})();